export function getActiveFiles(files) {
    let closeFiles=[]
    if(null !== files)
        files.map(file=>{

            if(file.approved === false && file.status !== "REJECTED"){
                closeFiles.push(file)
            }
        })
    return closeFiles;
}

export function getClosedFiles(files) {
    let closeFiles=[]
    if(null !== files)
        files.map(file=>{
            if(file.approved === true || file.status === "REJECTED"){
                closeFiles.push(file)
            }
        })
    return closeFiles;

}